// Grid spacing at the current zoom (1 plan unit = 1 cm), shared by the grid
// lines, the scale bar and snap-to-grid so all three always agree: the minor
// spacing is the smallest unit step that's at least MIN_GRID_PX on screen,
// the major one the next step up.

export const MIN_GRID_PX = 8;

const DIMS = {
  metric: [[1, '1 cm'], [10, '10 cm'], [100, '1 m'], [1000, '10 m'], [10000, '100 m'], [100000, '1 km']],
  imperial: [[2.54, '1 in'], [30.48, '1 ft'], [304.8, '10 ft'], [3048, '100 ft'], [30480, '1000 ft'], [304800, '10k ft']],
};

// { minor, major } as { abs (plan units), px (screen), label } — either can be
// null when zoomed out past the largest step.
export function gridSpacing(scale = 1, units = 'metric') {
  const dims = DIMS[units === 'imperial' ? 'imperial' : 'metric'];
  const visible = dims.map(([abs, label]) => ({ abs, px: abs * scale, label })).filter((d) => d.px >= MIN_GRID_PX);
  return { minor: visible[0] || null, major: visible[1] || null };
}

// The snap step (plan units) for a planner state: the minor grid spacing, so
// points land on minor grid intersections (the major lines sit on those too).
// 0 = snapping off (v1's snapToGrid setting).
export function snapStep(state) {
  if (!state?.settings?.snapToGrid) return 0;
  return gridSpacing(state.view?.scale || 1, state.settings.units).minor?.abs || 0;
}
